import React from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import {LinkBtn} from "../../elements/LinkBtn/linkBtn";
import {latLngBounds} from 'leaflet'
import "./leafletMap.scss";

export const LeafletMap = props => {

    if (typeof window !== 'undefined') {

        const defaultData = props.dataMap;
        const textStatic = props.textStatic;
        let bounds = latLngBounds([null, null]);

        defaultData.forEach((item) => {
            bounds.extend([parseFloat(item.latitude), parseFloat(item.longitude)]);
        });

        return (
            <MapContainer zoom={props.zoom} bounds={bounds} fitBounds={bounds}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
                />
                {defaultData.map((item, key) => {
                    return (
                        <Marker key={key} position={[parseFloat(item.latitude), parseFloat(item.longitude)]}>
                            <Popup>
                                {textStatic.map_component_office} {item.name} <br />
                                {item.url && <LinkBtn small to={`/${item.url}`} content={textStatic.map_component_view_office}/> }
                            </Popup>
                        </Marker>
                    )
                })}
            </MapContainer>
        );
    }
    return null
};

export default LeafletMap;